const priceBlocks = () => document.querySelectorAll('[data-puresetup-subscription-price]');
let selectedBillingCycle = new URLSearchParams(window.location.search).has('selling_plan') ? 'annual' : null;

function billingCycleFromElement(element) {
  let currentElement = element;

  for (let depth = 0; currentElement && depth < 6; depth += 1, currentElement = currentElement.parentElement) {
    const text = `${currentElement.getAttribute?.('aria-label') || ''} ${currentElement.textContent || ''}`.toLowerCase();
    const containsAnnual = text.includes('annual');
    const containsMonthly = text.includes('monthly');

    if (containsAnnual && !containsMonthly) return 'annual';
    if (containsMonthly && !containsAnnual) return 'monthly';
  }

  return null;
}

function billingCycleFromRadio(radio) {
  const directCycle = billingCycleFromElement(radio);
  if (directCycle) return directCycle;

  const planRadios = [...document.querySelectorAll('input[type="radio"]')];
  const radioIndex = planRadios.indexOf(radio);
  if (radioIndex === 0) return 'monthly';
  if (radioIndex === 1) return 'annual';

  return null;
}

function selectedBillingCycleFor(element) {
  if (selectedBillingCycle) return selectedBillingCycle;

  const planIds = [element.dataset.monthlySellingPlan, element.dataset.annualSellingPlan];
  const selectedRadio = [...document.querySelectorAll('input[type="radio"]:checked')].find((radio) =>
    planIds.includes(radio.value),
  );
  const selectedCycle = selectedRadio && billingCycleFromRadio(selectedRadio);
  if (selectedCycle) return selectedCycle;

  return 'monthly';
}

function updateSubscriptionPrice(block) {
  const isAnnual = selectedBillingCycleFor(block) === 'annual';
  const price = isAnnual ? block.dataset.annualPrice : block.dataset.monthlyPrice;
  const period = isAnnual ? ' / year' : ' / month';
  const priceElement = block.querySelector('[ref="priceContainer"] .price');

  if (!priceElement || !price) return;

  const currentPrice = `${price}${period}`;
  if (priceElement.textContent.trim() === currentPrice) return;

  priceElement.textContent = currentPrice;
  priceElement.setAttribute('aria-label', currentPrice);
}

function updatePlanCard(card) {
  const isAnnual = selectedBillingCycleFor(card) === 'annual';
  const priceElement = card.querySelector('[data-puresetup-plan-price]');
  const periodElement = card.querySelector('[data-puresetup-plan-period]');
  const price = isAnnual ? card.dataset.annualPrice : card.dataset.monthlyPrice;
  const period = isAnnual ? '/ year' : '/ month';

  if (priceElement && priceElement.textContent.trim() !== price) priceElement.textContent = price;
  if (periodElement && periodElement.textContent.trim() !== period) periodElement.textContent = period;
}

function syncSubscriptionPrices() {
  priceBlocks().forEach(updateSubscriptionPrice);
  document.querySelectorAll('[data-puresetup-plan-card]').forEach(updatePlanCard);
}

syncSubscriptionPrices();

[250, 1000, 2500].forEach((delay) => window.setTimeout(syncSubscriptionPrices, delay));

document.addEventListener('change', (event) => {
  if (!event.target.matches('input[type="radio"]')) return;

  const billingCycle = billingCycleFromRadio(event.target);
  if (billingCycle) selectedBillingCycle = billingCycle;
  syncSubscriptionPrices();
});

document.addEventListener('click', (event) => {
  const billingCycle = billingCycleFromElement(event.target);
  if (!billingCycle) return;

  selectedBillingCycle = billingCycle;
  window.setTimeout(syncSubscriptionPrices, 0);
});
